import * as React from "react";
import { observer } from "mobx-react";
import { AppStore } from "../../stores/AppStore";
import { Alert, Alignment, Button, Classes, Dialog, FormGroup, Tab, Tabs, Tag } from "@blueprintjs/core";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { IEmpresa, newEmpresa } from "../../model";
import { observable } from "mobx";
import { formatCnpj } from "../../utils";
import { BootstrapTable, TableHeaderColumn, SearchField } from "react-bootstrap-table";
import { MDBBtn, MDBCol, MDBDropdown, MDBDropdownMenu, MDBDropdownToggle, MDBRow } from "mdbreact";
import moment from "moment";
import { Pager } from "../utils/Pager";
import CaixaPostalSolicitacao from "./CaixaPostalMensagem";
import { CaixaPostalStore } from "../../stores/caixa-postal/CaixaPostalStore";
import { toast } from "react-toastify";
import { DateRangePicker } from "../utils/DateRangePicker";
import CaixaPostalAssunto from "./CaixaPostalAssunto";
import { getTag } from "../utils/getStatus";
import LoadingModal from "../loading/LoadingModal";

@observer
export default class CaixaPostalPage extends React.Component<{}, {}> {

    obs = observable({
        selectedTab: "solicitacao" as string,
        tarefas_page: 1 as number,
        tarefas_length: 0 as number,
        assuntos: [] as any,
        selectedPeriod: [] as any,
        open_visualiza_erro: false as boolean,
        mensagem_erro: "" as string
    })

    constructor(props: {}) {
        super(props);
        AppStore.setTitle("Caixa Postal");
        CaixaPostalStore.handleConsultaCredito()
    }

    componentDidMount(): void {
        if (CaixaPostalStore.obs.mensagens_pendentes.length > 0) {
            CaixaPostalStore.obs.open_empresas_mensagens = true
        }
    }

    handleBuscaTarefasPaged = async (page: number) => {
        this.obs.tarefas_page = page
        CaixaPostalStore.obs.loading_solicitacoes = true
        CaixaPostalStore.handleTasksPaged(page, CaixaPostalStore.obs.select_empresa.cnpj, CaixaPostalStore.obs.data1, CaixaPostalStore.obs.data2);
    };

    async handleChangeTab(tabId: string) {
        await CaixaPostalStore.handleConsultaCredito()

        this.obs.selectedTab = tabId

    }

    handleBuscaTarefas = async () => {
        if (CaixaPostalStore.obs.select_empresa.cnpj == "") {
            toast.warning('Selecione uma empresa!', {});
            return;
        }

        if (CaixaPostalStore.obs.data1 == "") {
            toast.warning('Selecione um período válido', {});
            return
        }
        if (CaixaPostalStore.obs.data2 == "") {
            toast.warning('Selecione um período válido', {});
            return
        }

        CaixaPostalStore.obs.loading_solicitacoes = true
        await CaixaPostalStore.handleTasksPaged(this.obs.tarefas_page, CaixaPostalStore.obs.select_empresa.cnpj, CaixaPostalStore.obs.data1, CaixaPostalStore.obs.data2);
    };

    handleDateSolicitacaoChange = (val: any) => {

        CaixaPostalStore.obs.data1 = moment(val[0]).format("YYYY-MM-DD")
        CaixaPostalStore.obs.data2 = moment(val[1]).format("YYYY-MM-DD")

        this.obs.selectedPeriod = val;
    };

    render() {

        let empresaText = CaixaPostalStore.obs.select_empresa.razao_social != ""
            ? `${CaixaPostalStore.obs.select_empresa.razao_social.substring(0, 38)}... (${formatCnpj(CaixaPostalStore.obs.select_empresa.cnpj)})`
            : "Selecione uma empresa";

        function statusFormatter(cell, row) {

          return getTag(row.status);

        }

        function dateFormatter(cell, row) {
            return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " ás " + moment(cell).add(3, "hour").format("HH:mm");
        };

        function cnpjFormatter(cell, row) {
            if (row.cnpj) {
                let emp = EmpresaStore.getByCnpj(row.cnpj);
                if (emp) {
                    return `${emp.razao_social.substring(0, 30)} - ${formatCnpj(row.cnpj)}`
                }
            }

            return ""
        };

        const buttonFormatterDetalhes = (cell, row) => {
            return (
                <>
                    <MDBBtn color="default" rounded size="sm" onClick={(e) => handleViewDetalhes(row)}>
                        <img src="/images/e-mail.png" width="18px" />
                    </MDBBtn>
                </>
            )

        }

        const buttonFormatterErros = (cell, row) => {
            return (
                <>
                    {!row.dados && row.error &&
                        <MDBBtn color="default" rounded size="sm" onClick={(e) => handleViewErro(row)}>
                            <img src="/images/view.png" width="18px" />
                        </MDBBtn>
                    }
                </>
            )
        }

        const handleViewDetalhes = async (row) => {
            await CaixaPostalStore.handleConsultaCredito()

            if (row.dados) {

                if (row.dados.conteudo.length > 0) {

                    this.obs.assuntos = row.dados.conteudo[0].listaMensagens

                    this.obs.assuntos.map((value, index) => {
                        value.index = index
                        value.caixapostal_id = row.caixapostal_id
                        value.id = row._id
                    })

                    CaixaPostalStore.obs.open_mensagens = true
                } else {

                    toast.warning('Contribuinte não possui mensagem!', {});
                    return

                }

            } else {

                toast.warning('Contribuinte não possui mensagem!', {});
                return
            }

        }

        const handleViewErro = async (row) => {
            this.obs.mensagem_erro = row.error
            this.obs.open_visualiza_erro = true
        }

        return (
            <>


                <Tabs
                    id="tabs"
                    className={"tabsCalculos"}
                    selectedTabId={this.obs.selectedTab}
                    onChange={(tabId) => this.handleChangeTab(String(tabId))}
                >

                    <Tab
                        id="solicitacao"
                        title="Solicitação"
                        panel={<CaixaPostalAssunto />} />

                    <Tab
                        id="msg"
                        title="Mensagens"
                        panel={<>

                            <MDBRow>
                                <MDBCol md="3">
                                    <FormGroup className="empresaSelect" label="Empresa">
                                        <EmpresaSelect
                                            items={EmpresaStore.sortedEmpresas?.filter(x => x["caixapostal_automatica"])}
                                            itemRenderer={renderEmpresa}
                                            itemPredicate={filterEmpresa}
                                            onItemSelect={(e: IEmpresa) => CaixaPostalStore.obs.select_empresa = e}
                                            inputProps={{ placeholder: "Filtrar uma empresa" }}
                                        >
                                            <Button
                                                text={empresaText}
                                                rightIcon="double-caret-vertical"
                                                alignText={Alignment.LEFT}
                                            />
                                        </EmpresaSelect>
                                    </FormGroup>
                                </MDBCol>

                                <MDBCol md="3">
                                    <FormGroup label="Período" className="inputsPeriodoCalculos">
                                        <DateRangePicker
                                            onChange={this.handleDateSolicitacaoChange}
                                            value={this.obs.selectedPeriod}
                                        />
                                    </FormGroup>
                                </MDBCol>

                                <MDBCol md="2">
                                    <MDBBtn
                                        className="btnDefault btnBuscarNfe mt25"
                                        onClick={() => this.handleBuscaTarefas()}
                                    >
                                        Buscar
                                    </MDBBtn>
                                </MDBCol>
                            </MDBRow>

                            <div>
                                <BootstrapTable className="TableDefault" ref="table" data={CaixaPostalStore.obs.tasks_caixa_postal}>
                                    <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%"> # </TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={dateFormatter} dataField="inserted_at" width="20%">Data da Solicitação</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={cnpjFormatter} width="30%">Empresa</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={statusFormatter} width="20%">Status</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={buttonFormatterDetalhes} width="10%">Detalhes</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={buttonFormatterErros} width="10%">Erros</TableHeaderColumn>
                                </BootstrapTable>
                            </div>

                            <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
                                <Pager
                                    currentPage={this.obs.tarefas_page}
                                    totalCount={CaixaPostalStore.obs.tasks_length}
                                    pageSize={15}
                                    onPageChange={page => this.handleBuscaTarefasPaged(this.obs.tarefas_page = page)}
                                />
                            </div>

                        </>} />
                </Tabs>

                <LoadingModal open={CaixaPostalStore.obs.loading_solicitacoes} onClose={() => CaixaPostalStore.obs.loading_solicitacoes = false} title={"Buscando solicitações"} />

                <Dialog
                    isOpen={CaixaPostalStore.obs.open_mensagens}
                    onClose={() => CaixaPostalStore.obs.open_mensagens = false}
                    title={"Solicitar Mensagens"}
                >
                    <div className={Classes.DIALOG_BODY}>
                        <CaixaPostalSolicitacao itens={this.obs.assuntos} cnpj={CaixaPostalStore.obs.select_empresa.cnpj} />
                    </div>
                </Dialog>

                <Dialog
                    isOpen={CaixaPostalStore.obs.open_empresas_mensagens}
                    onClose={() => CaixaPostalStore.obs.open_empresas_mensagens = false}
                    title={"Contribuintes com novas mensagens"}
                    className="modal-mensagens"
                >
                    <div className={Classes.DIALOG_BODY}>
                        <p style={{ marginBottom: 25, marginTop: -25 }}>
                            Para visualizar as mensagens das empresas listadas abaixo, é necessário realizar uma solicitação na aba <b>Solicitação</b>.
                        </p>

                        <div className="table-mensagens">
                            <div className="dropdownNotification text-mensagens">
                                {CaixaPostalStore.obs.mensagens_pendentes?.map((el: any) => {
                                    let empresa = EmpresaStore.getByCnpj(el.cnpj)
                                    if (empresa) {
                                        return (
                                            <>
                                                <p>
                                                    Contribuinte
                                                    {" "}<b>{empresa.razao_social} - ({formatCnpj(el.cnpj)})</b>{" "}
                                                    {el.indicadorMensagensNovas == 0 && "não possui mensagens novas."}
                                                    {el.indicadorMensagensNovas == 1 && "possui uma mensagem nova."}
                                                    {el.indicadorMensagensNovas == 2 && "possui mensagens novas."}
                                                </p>
                                            </>
                                        )
                                    }
                                })}
                            </div>
                        </div>
                    </div>
                    <div className={Classes.DIALOG_FOOTER}>
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button text="Fechar" intent="primary" onClick={() => CaixaPostalStore.obs.open_empresas_mensagens = false} />
                        </div>
                    </div>
                </Dialog>

                <LoadingModal open={CaixaPostalStore.obs.loading_solicitacao} onClose={() => CaixaPostalStore.obs.loading_solicitacao = false} title={"Criando solicitação"} />

                <Dialog
                    isOpen={this.obs.open_visualiza_erro}
                    onClose={(e) => this.obs.open_visualiza_erro = false}
                    title={"Erros"}
                    style={{ width: 600 }}
                >
                    <div className={Classes.DIALOG_BODY}>

                        {this.obs.mensagem_erro}

                    </div>

                </Dialog>

            </>
        );
    }
}
